<template>
  <div class="registry-key-selector__wrapper">
    <custom-select
      v-model="selectedModel"
      :options="options"
      :input-id="inputId"
      :placeholder="placeholder"
      :searchable="true"
      :filterable="false"
      :clearable="clearable"
      clear-search-on-select="false"
      :error="error"
      :value="selectedModel?.uuid"
      @input="onChange"
      @open="onOpen"
      @close="onClose"
      @search="onSearch"
    ></custom-select>
    <input
      v-if="hiddenInputName"
      :name="hiddenInputName"
      type="hidden"
      :value="selectedModel ? selectedModel?.uuid : null"
    />

    <div
      v-if="selectedModel"
      class="registry-key-selector__wrapper__key-info"
    >
      <span class="registry-key-selector__wrapper__key-info__item">
        <b>{{ $t('settings.titles.keyInfoAddress') }}:</b>
        {{ selectedModel.email }}
      </span>
      <span class="registry-key-selector__wrapper__key-info__item">
        <b>{{ $t('settings.titles.keyInfoPublic') }}:</b>
        {{ selectedModel.keyId }}
      </span>
      <span class="registry-key-selector__wrapper__key-info__item">
        <b>{{ $t('settings.titles.keyInfoAddDate') }}:</b>
        {{ $moment(selectedModel.addTime).format('dddd, D MMMM YYYY г.') }}
      </span>
      <span class="registry-key-selector__wrapper__key-info__item">
        <b>{{ $t('settings.titles.keyInfoExpireDate') }}:</b>
        {{ selectedModel.endData }}
      </span>
    </div>
    <div
      v-else
      class="registry-key-selector__wrapper__no-selected-key"
    >
      Ключевая пара GPG для формирования подписи пакета не выбрана
    </div>
  </div>
</template>

<script>
import CustomSelect from '@shared/shared-components/shared/custom-select.vue';
import RegistryMessages from '@/shared-modules/modules/registry/registry.messages.js';
import RegistryService from '@/shared-modules/modules/registry/registry.service.js';
export default {
  components: { CustomSelect },
  name: 'RegistryKeySelector',
  props: {
    hiddenInputName: {
      type: String,
      default: 'debSignedKeyFingerprint'
    },
    error: { default: null },
    placeholder: {
      default() {
        return this.$t('settings.placeholders.selectGpgKey');
      }
    },
    inputId: {
      type: String,
      default: null
    },
    entityType: {
      type: String,
      default: 'project' // project || company
    },
    userAlias: {
      type: String,
      default: null
    },
    projectAlias: {
      type: String,
      default: null
    },
    companyAlias: {
      type: String,
      default: null
    },
    packageType: {
      type: String,
      default: null
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      options: [
        {
          title: 'Не выбрано'
        }
      ],
      selectedModel: null,
      showLoader: true
    };
  },
  // computed: {
  //   userAlias() {
  //     return this.$store.getters.getUserAlias;
  //   }
  // },
  mounted() {
    this.getSelectedOption();
  },
  methods: {
    getOptions() {
      RegistryService.getUserGpgKeys().then((options) => {
        this.options = options;
      });
    },
    getSelectedOption() {
      switch (this.entityType) {
        case 'project':
          this.getSelectedProjectGpgKey();
          break;
        case 'company':
          this.getSelectedCompanyGpgKey();
          break;
        case 'instance':
          this.getSelectedInstanceGpgKey();
          break;
        default:
          break;
      }
    },
    getSelectedCompanyGpgKey() {
      RegistryService.getSelectedCompanyGpgKey(this.companyAlias, this.packageType).then((data) => {
        this.selectedModel = data;
      });
    },
    getSelectedProjectGpgKey() {
      RegistryService.getSelectedProjectGpgKey(
        this.userAlias,
        this.projectAlias,
        this.packageType
      ).then((data) => {
        this.selectedModel = data;
      });
    },
    getSelectedInstanceGpgKey() {
      RegistryService.getSelectedInstanceGpgKey(this.packageType).then((data) => {
        this.selectedModel = data;
      });
    },
    onChange() {},
    onOpen() {
      this.getOptions();
    },
    onClose() {},
    onSearch() {}
  },
  i18n: {
    messages: RegistryMessages
  }
};
</script>

<style lang="scss">
$this: '.registry-key-selector';

#{$this} {
  &__wrapper {
    &__key-info {
      display: flex;
      flex-direction: column;
      padding: 12px 8px 0 8px;
      color: var(--text-muted);

      &__item {
        margin-bottom: 0.25rem;
      }
    }
    &__no-selected-key {
      display: flex;
      justify-content: center;
      padding: 1rem;
      margin-top: 1rem;
      border: 1px solid var(--border-color);
      border-radius: 0.4rem;
      background-color: var(--bg-light);
    }
  }
}
</style>
